import { useMutation } from "@apollo/client";
import {
  PencilIcon,
  TrashIcon,
  // EyeIcon,
} from "@heroicons/react/24/outline";
import { Button, IconButton, Modal } from "../../../../../../../components/ui";
import AddAuction from "./AddAuction";
import { DELETE_INSTANCE_AUCTION } from "../../../../../../../graphql/mutation/InstanceAuction";

const Actions = props => {
  const { id, contact, values } = props || {};
  const [deleteInstanceAuction, { loading }] = useMutation(
    DELETE_INSTANCE_AUCTION,
  );

  const editModalProps = {
    body: AddAuction,
    contact,
    closeOnBackdrop: true,
    auction: values?.rawFields,
    hideCloseButton: true,
    scale: "md",
  };

  const deleteModalProps = {
    title: "Are you sure?",
    scale: "sm",
    description: `Would you like to delete auction '${values?.event || ""}'?`,
    closeOnBackdrop: true,
    renderBody: ({ closeModal }) => {
      const handleDelete = () => {
        deleteInstanceAuction({
          variables: {
            input: { id: +values?.rawFields?.id },
          },
          update: (cache, { data }) => {
            const { deleteInstanceAuction: { success } = {} } = data;
            if (success) {
              closeModal();
              cache.evict({
                id: cache.identify({
                  __typename: "InstanceAuction",
                  id,
                }),
              });
            }
          },
        });
      };

      return (
        <div className="mt-4 flex">
          <Button
            className="mr-3"
            label={"Cancel"}
            action={"default"}
            onClick={() => {
              closeModal?.();
            }}
          />
          <Button
            label={loading ? "Deleting" : "Delete"}
            disabled={loading}
            onClick={handleDelete}
          />
        </div>
      );
    },
  };

  if (typeof id == "number") {
    return (
      <div className="user-list-actions flex text-right text-sm font-medium">
        {id && (
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
            <Modal {...editModalProps}>
              <IconButton variant="clean" title="Edit Auction">
                <PencilIcon
                  className={`h-4 w-4 cursor-pointer text-gray-400`}
                />
              </IconButton>
            </Modal>
            {/* <IconButton variant="clean" title="View Auction">
              <EyeIcon
                className={`h-4 w-4 cursor-pointer text-gray-400`}
                onClick={() => {}}
              />
            </IconButton> */}
            <Modal {...deleteModalProps}>
              <IconButton variant="clean" title="Delete Material">
                <TrashIcon className={`h-4 w-4 cursor-pointer text-gray-400`} />
              </IconButton>
            </Modal>
          </div>
        )}
      </div>
    );
  } else {
    return false;
  }
};

export default Actions;
